import axios from "axios";

class UserMessagesService {
    constructor() {
        this.sysList = this.sysList.bind(this);
        this.busList = this.busList.bind(this);
        this.adsList = this.adsList.bind(this);
    }

    async sysList(page) {
        return await axios.get(`/api/v1/system/messages?page=${page}`)
            .then(response => response.data);
    }

    async busList() {
        return await axios.get('/api/v1/messages/bus')
            .then(response => response.data);
    }

    async adsList(page) {
        return await axios.get(`/api/v1/messages/ads?page=${page}`)
            .then(response => response.data);
    }

    async setSysRead(messageId, jobId) {
        return await axios.put('/api/v1/system/messages', {
           message_id: messageId,
           job_id: jobId
        });
    }

    async setBusRead(messageId) {
        return await axios.put('/api/v1/messages/bus', {
           message_id: messageId
        });
    }

    async setAdsRead(messageId) {
        return await axios.put('/api/v1/messages/ads', {
           message_id: messageId
        });
    }
    async setAllAdsRead() {
        return await axios.post('/api/v1/messages/ads');
    }
    async setAllBusRead() {
        return await axios.post('/api/v1/messages/bus');
    }
    async setAllSysRead() {
        return await axios.post('/api/v1/system/messages');    
    }
}

const userMessagesService = new UserMessagesService();
export default userMessagesService;